import React from "react";
import classNames from "classnames";
import { CreatedBy } from "../PublicViewRender";
import bg from "../../../../../assets/siteFormBg.png";
const SingleFormPage = ({
  heading,
  tableData,

  remark,
  createdBy,
  creationDate,
  isPdf,
}) => {
  return (
    <div className="w-full h-full bg-white flex flex-col gap-1 relative">
      <div
        className={`bg-[#06565E] playfair text-[#EABC9D] text-xl sm:text-3xl text-center font-bold italic py-1 sm:py-2 `}
      >
        <>
          {isPdf ? (
            <span className="text-center w-full relative bottom-3.5">
              {heading}
            </span>
          ) : (
            <>{heading}</>
          )}
        </>
      </div>
      <div
        style={{
          backgroundImage: `url(${bg})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className={`grow min-h-0 relative flex flex-col overflow-hidden ${
          isPdf && "bottom-1"
        }`}
      >
        {tableData && Array.isArray(tableData) && tableData.length && (
          <div className="grow min-h-0 flex flex-col justify-center items-center">
            <table className="w-full inter ">
              {tableData.map((row, i) => (
                <tr
                  className={classNames(
                    "w-full",
                    i % 2 == 0 ? "bg-[#E0B1614D]" : "bg-transparent",
                    "p-2",
                  )}
                >
                  <td className={classNames("p-2 pl-4 text-xs text-[#60607B]")}>
                    <>
                      {isPdf ? (
                        <span className="relative bottom-1.5">{row.label}</span>
                      ) : (
                        <>{row.label}</>
                      )}
                    </>
                  </td>
                  <td
                    className={classNames(
                      "text-right p-2 pr-4 text-xs font-[600]",
                    )}
                  >
                    {typeof row.value === "string" &&
                    /^https?:\/\/\S+$/.test(row.value) ? (
                      <a
                        href={row.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 underline hover:text-blue-600"
                      >
                        <>
                          {isPdf ? (
                            <span className="relative bottom-1.5">
                              {" "}
                              {row.value}
                            </span>
                          ) : (
                            <>{row.value}</>
                          )}
                        </>
                      </a>
                    ) : (
                      <>
                        {isPdf ? (
                          <span className="relative bottom-1.5">
                            {" "}
                            {row.value}
                          </span>
                        ) : (
                          <>{row.value}</>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </table>
          </div>
        )}
        {remark && (
          <div
            className={` min-h-0 flex items-center justify-center  pt-2 pb-8 ${
              !(tableData && Array.isArray(tableData) && tableData.length) &&
              "grow"
            }`}
          >
            <div className="w-[96%] mx-auto   bg-[#06565E1A] border-[#06565E] border-2 rounded-xl p-4 ">
              <div
                className={`max-w-[100%] inter  mx-auto ${isPdf && "relative bottom-2"}`}
              >
                <span className="playfair text-[#06565E] font-semibold">
                  {" "}
                  Remark -
                </span>{" "}
                <span className="playfair ">{remark} </span>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* {remark && (
            <div className=" absolute bottom-6 w-full">
          <div className="w-[96%] mx-auto   mt-4  bg-[#06565E1A] border-[#06565E] border-2 rounded-xl p-4 ">
            <div className="max-w-[90%]  mx-auto ">
              <span className="playfair text-[#06565E] font-semibold">
                {" "}
                Remark -
              </span>{" "}
              <span className="playfair ">{remark} </span>
            </div>
          </div>
          </div>
        )} */}
      {/* <div style={{lineHeight: "15px"}} className="py-0 bg-black/30 text-white  text-center  text-xs flex-shrink-0 absolute bottom-0 left-0 px-2 text-[10px]  ">
        {createdBy}
      </div> */}
      <div
        className={`absolute ${
          isPdf ? "-bottom-1 -left-1" : "-bottom-2 -left-3"
        }  w-fit text-nowrap `}
      >
        <CreatedBy username={createdBy} date={creationDate} isPdf={isPdf} />
      </div>
    </div>
  );
};

export default SingleFormPage;
